export default "__VITE_ASSET__cea438da__"